var Backbone, SupportHelpWizardController, SupportStepActionsView, getTrackingHubData,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportHelpWizardController = require('../helpWizardController');

Backbone = require('backbone');

Backbone.$ = $;

SupportStepActionsView = (function(superClass) {
  extend(SupportStepActionsView, superClass);

  function SupportStepActionsView() {
    return SupportStepActionsView.__super__.constructor.apply(this, arguments);
  }

  SupportStepActionsView.prototype.className = 'row step-actions';

  SupportStepActionsView.prototype.initialize = function(options) {
    this.options = options || {};
    this.template = this.options.template;
    this.I18nScope = 'modules.support';
    return this.model = Groupon.Support.stepActionModel;
  };

  SupportStepActionsView.prototype.events = {
    'click #continue-with-order': 'continueWithOrder',
    'click #not-order-related': 'notOrderRelated',
    'click .back': 'goToPreviousStep',
    'click #problem-solved': 'renderProblemSolved',
    'click #contact-us': 'contactUs',
    'click #request-refund': 'continueToTicket',
    'click #continueToTicket': 'continueToTicket',
    "click #orderNotListed": "orderNotListed",
    "click #chooseOrder": "chooseDifferentOrder",
    'click #otherContactChannel': 'chooseDifferentContactChannel'
  };

  SupportStepActionsView.prototype.render = function() {
    this.$el.append(toHtml(this.template, this.model.toHash(), this.I18nScope));
    return this.delegateEvents();
  };

  SupportStepActionsView.prototype.continueWithOrder = function() {
    $("#continue-with-order").hide();
    Groupon.Support.NOT_ORDER_RELATED = false;
    return propagateEventBeforeReplacingElements(function() {
      return Backbone.history.navigate("#select-issue", {
        trigger: true
      });
    });
  };

  SupportStepActionsView.prototype.contactUs = function() {
    var data;
    data = getTrackingHubData();
    TrackingHub.add("still-need-help", {
      stillNeedHelp: data
    });
    return propagateEventBeforeReplacingElements(function() {
      return Backbone.history.navigate('#contact-us', {
        trigger: true
      });
    });
  };

  SupportStepActionsView.prototype.continueToTicket = function() {
    var data;
    data = getTrackingHubData();
    TrackingHub.add("continue-to-ticket", {
      continueToTicket: data
    });
    return propagateEventBeforeReplacingElements(function() {
      this.$('.refund-my-request').hide();
      return Backbone.history.navigate('#contact-us', {
        trigger: true
      });
    });
  };

  SupportStepActionsView.prototype.renderProblemSolved = function() {
    var data;
    data = getTrackingHubData();
    TrackingHub.add("problem-solved", {
      problemSolved: data
    });
    return propagateEventBeforeReplacingElements(function() {
      return Backbone.history.navigate('#problem-solved', {
        trigger: true
      });
    });
  };

  SupportStepActionsView.prototype.notOrderRelated = function() {
    var data;
    Groupon.Support.NOT_ORDER_RELATED = true;
    data = {
      permalink: window.currentUser != null ? window.currentUser.id : "anonymous"
    };
    TrackingHub.add("order-not-related", {
      orderNotRelated: data
    });
    return propagateEventBeforeReplacingElements(function() {
      SupportHelpWizardController.changeCurrentOrder(null);
      return Backbone.history.navigate("#select-issue", {
        trigger: true
      });
    });
  };

  SupportStepActionsView.prototype.orderNotListed = function() {
    Groupon.Support.ORDER_NOT_LISTED = true;
    Groupon.Support.NOT_ORDER_RELATED = false;
    SupportHelpWizardController.changeCurrentOrder(null);
    Backbone.history.navigate('#select-issue', {
      trigger: true
    });
    return false;
  };

  SupportStepActionsView.prototype.chooseDifferentContactChannel = function() {
    return SupportHelpWizardController.stepThree();
  };

  SupportStepActionsView.prototype.chooseDifferentOrder = function() {
    SupportHelpWizardController.changeCurrentOrder(null);
    return SupportHelpWizardController.initOrdersFetch();
  };

  SupportStepActionsView.prototype.goToPreviousStep = function() {
    var index;
    if (Groupon.Support.MAXINDEX === 3) {
      index = Groupon.Support.CURRENTVIEW.id;
    } else {
      index = Groupon.Support.CURRENTVIEW.id + 1;
    }
    switch (index) {
      case 3:
        return propagateEventBeforeReplacingElements(function() {
          return Backbone.history.navigate('#select-issue', {
            trigger: true
          });
        });
      case 2:
        return propagateEventBeforeReplacingElements(function() {
          window.selectOrderFromMygroupons = false;
          return Backbone.history.navigate('#pick-order', {
            trigger: true
          });
        });
    }
  };

  return SupportStepActionsView;

})(Backbone.View);

getTrackingHubData = function() {
  var ref, ref1;
  return {
    category: (ref = Groupon.Support.ContentModel.getCategory()) != null ? ref.id : void 0,
    subCategory: (ref1 = Groupon.Support.ContentModel.getSubCategory()) != null ? ref1.id : void 0,
    permalink: window.currentUser != null ? window.currentUser.id : "anonymous"
  };
};

module.exports = SupportStepActionsView;

//# sourceMappingURL=data:application/json;base64,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
